export enum ClassItemType {
  enps = 'enps',
  ees = 'ees',
  esat = 'esat',
  ees7emoji = 'ees7Emoji',
  ees7stars = 'ees7Stars',
  likeDislike = 'likeDislike',
  nps = 'nps',
  csat = 'csat',
  csat10 = 'csat10',
  ces = 'ces',
  csat5Stars = 'csat5Stars',
  optionalLikeDislike = 'optionalLikeDislike',
  ces7emoji = 'ces7Emoji',
  ces7stars = 'ces7Stars',
}
